"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var style_1 = require("../../../style");
var layout_1 = require("../../layout");
var styles_1 = require("./styles");
var Dots = function (_a) {
    var _b = _a.total, total = _b === void 0 ? 0 : _b, activeIndex = _a.activeIndex, onChange = _a.onChange, _c = _a.theme, dotsTheme = _c === void 0 ? 'light' : _c;
    var theme = style_1.useTheme();
    var styles = styles_1.getDotsStyles(theme, dotsTheme);
    var activeDotStyles = {
        light: theme.color.GRAY.LIGHT_2,
        dark: '#fff',
    };
    var dots = Array.from({ length: total }, function (_, idx) { return (react_1.jsx("button", { key: idx, css: react_1.css([
            styles.dot,
            activeIndex === idx
                ? react_1.css({
                    backgroundColor: activeDotStyles[dotsTheme],
                })
                : undefined,
        ]), onClick: function () { return onChange === null || onChange === void 0 ? void 0 : onChange(idx); } })); });
    return (react_1.jsx(layout_1.Flex, { alignItems: "center", justifyContent: "center", gap: 12, css: styles.container }, dots));
};
exports.default = Dots;
